import React, { useState, useEffect } from 'react';
import API from '../Api';
import SubPageHeader from '../../components/common/SubPageHeader';

const Videos = () => {
  const [feedbackData, setFeedbackData] = useState([]); 
  const [currentIndex, setCurrentIndex] = useState(0);
  const getYouTubeID = (url) => {
      if (!url) return '';
      if (url.includes('embed/')) return url.split('embed/')[1];
      if (url.includes('v=')) return url.split('v=')[1].split('&')[0];
      return url;
  };

 
  useEffect(() => {
    const fetchVideos = async () => {
      try {
        const res = await API.get('admin/get-all-feedbacks/');
        
        
        if (res.data && res.data.length > 0) {
            setFeedbackData(res.data);
        } else {
           
            const defaultVideos = [
                { feedbackid: 'd1', feedbacktitle: "Mission 2020", feedbackdesc: "Feedback mission 2020", feedbacklink: "vxYmsD-NcmU" },
                { feedbackid: 'd2', feedbacktitle: "MISSION2020", feedbackdesc: "THE BEST YEAR OF MY LIFE", feedbacklink: "99j6B5ujBSo" },
                { feedbackid: 'd3', feedbacktitle: "MISSION2020 FEEDBACK", feedbackdesc: "FIRST SESSION 2020", feedbacklink: "IIKM9dEtyug" }
            ];
            setFeedbackData(defaultVideos);
        }
      } catch (err) {
        console.error("Error fetching videos:", err);
       
        setFeedbackData([
            { feedbackid: 'd1', feedbacktitle: "Mission 2020", feedbackdesc: "Feedback mission 2020", feedbacklink: "vxYmsD-NcmU" },
            { feedbackid: 'd2', feedbacktitle: "MISSION2020", feedbackdesc: "THE BEST YEAR OF MY LIFE", feedbacklink: "99j6B5ujBSo" },
            { feedbackid: 'd3', feedbacktitle: "MISSION2020 FEEDBACK", feedbackdesc: "FIRST SESSION 2020", feedbacklink: "IIKM9dEtyug" }
        ]);
      }
    };
    fetchVideos();
  }, []);
  const currentVideo = feedbackData[currentIndex];

  const nextSlide = () => {
    setCurrentIndex((prev) => (prev === feedbackData.length - 1 ? 0 : prev + 1));
  };

  const prevSlide = () => {
    setCurrentIndex((prev) => (prev === 0 ? feedbackData.length - 1 : prev - 1));
  };

  
  if (feedbackData.length === 0) return <div className="text-center pt-32">Loading Videos...</div>;

  return (
    <div className="w-full min-h-screen bg-white flex flex-col items-center pt-32 pb-12">
      <SubPageHeader title="Videos" />
      
      <div className="relative z-10 w-full max-w-4xl px-4 text-center">
        <h1 className="text-4xl md:text-6xl font-semibold mb-2">FeedBack</h1>
        
        <div className="flex flex-col items-center mb-8">
            <div className="flex gap-1 mb-4">
                <div className="w-8 h-[2px] bg-blue-900/50"></div>
                <div className="w-8 h-[2px] bg-blue-900/50"></div>
            </div>
            <h2 className="text-2xl md:text-3xl uppercase tracking-widest font-light text-blue-900">
                {feedbackData[currentIndex].feedbacktitle} 
            </h2>
        </div>

        {/* Video Container */}
        <div className="relative aspect-video w-full max-w-3xl mx-auto border-[8px] border-blue-900 rounded shadow-2xl overflow-hidden bg-black transition-all duration-500">
          <iframe
            className="w-full h-full"
            
            src={currentVideo.feedbacklink.includes('embed/') 
                ? currentVideo.feedbacklink 
                : `https://www.youtube.com/embed/${getYouTubeID(currentVideo.feedbacklink)}`}
            title="YouTube video player"
            frameBorder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen
          ></iframe>
        </div>

        <p className="mt-6 text-lg md:text-xl uppercase tracking-wider font-medium text-gray-800">
          {feedbackData[currentIndex].feedbackdesc}
        </p>

        {/* Navigation */}
        <div className="flex justify-center gap-8 mt-12">
          <button onClick={prevSlide} className="w-14 h-14 rounded-full border-2 border-blue-900 flex items-center justify-center hover:bg-blue-900 hover:text-white transition-all text-3xl font-light">
            &#8249;
          </button>
          <button onClick={nextSlide} className="w-14 h-14 rounded-full border-2 border-blue-900 flex items-center justify-center hover:bg-blue-900 hover:text-white transition-all text-3xl font-light">
            &#8250;
          </button>
        </div>
      </div>
    </div>
  );
};

export default Videos;